import PropTypes from 'prop-types';
import { FormikInput } from '@febos-io/design';

import { useTranslation } from '../../../hooks';
import { InputProps } from './types';

export function FilterInput({ name, config }: InputProps) {
  const { t } = useTranslation();

  return (
    <>
      <FormikInput
        name={`${name}[0]`}
        type={config.typeNumber}
        label={`${t(config.name || '')}`}
        placeholder={`${t(config.name || '')}`}
      />
      {config.message && (
        <div className="mt-1 text-primary text-center">
          <small>
            <strong>{config.message}</strong>
          </small>
        </div>
      )}
    </>
  );
}

FilterInput.propTypes = {
  name: PropTypes.string,
  config: PropTypes.object
};

export default FilterInput;
